import { db } from "./firebase";
import {
  collection,
  doc,
  updateDoc,
  getDoc,
  getDocs,
  addDoc,
  deleteDoc,
  onSnapshot,
} from "firebase/firestore";

const collectionName = process.env.VUE_APP_FB_COLLECTION;
const terminalsRef = collection(db, collectionName);

export const createTerminal = async (note: any): Promise<any> => {
  const newDoc = await addDoc(terminalsRef, note);
  return {
    id: newDoc.id,
    ...note,
  };
};

export const getTerminal = async (id: string): Promise<any> => {
  const terminalDoc = doc(db, collectionName, id);
  const querySnapshot = await getDoc(terminalDoc);
  const data = querySnapshot.data();
  return data;
};

export const getTerminals = async (): Promise<any[]> => {
  const querySnapshot = await getDocs(terminalsRef);
  return querySnapshot.docs.map((doc) => {
    const data = doc.data();
    return data;
  });
};

export const updateTerminal = async (terminal: any): Promise<any> => {
  const terminalRef = doc(db, collectionName, terminal.id);
  await updateDoc(terminalRef, terminal);
  return terminal;
};

export const deleteTerminal = async (id: string): Promise<string> => {
  const terminalDoc = doc(db, collectionName, id);
  await deleteDoc(terminalDoc);
  return id;
};

export const terminalListner = async (
  id: string,
  callback: (doc: any) => void
): Promise<any> => {
  const terminalDoc = doc(db, collectionName, id);
  // const gett = await getDoc(terminalDoc);
  return onSnapshot(terminalDoc, (doc) => {
    callback(doc);
  });
};
